<template>
  <div
    v-if="announces && announces.length > 0"
    class="announce-widget">
    <h4>お知らせ</h4>
    <v-card class="announce-widget--container">
      <v-list
        lines="three"
        rounded="lg"
      >
        <v-list-item
          v-for="(item, i) in announces"
          :key="i"
          @click="clickAnnounce(item.id)"
        >
          <template v-slot:title>{{formatDate(item.publishedAt?.toString())  || formatDate(item.createdAt?.toString())}}</template>
          <template v-slot:subtitle>{{item.title? item.title : omittedText30(item.message)}}</template>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
  <AnnounceDialog
    v-model:open="openAnnounceDialog"
    @success="successAnnounceDialog"
    @cancel="cancelAnnounceDialog"
    :data="announces?.find(announce =>{return announceId == announce.id})"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useFormatFunc } from '@/utils/formatter';
import * as api from '@/api/okaso-api'
import { useQuery } from '@vue/apollo-composable'
import AnnounceDialog from '@/components/organisms/dialogs/AnnounceDialog.vue'
import { useUrlFunc } from '@/utils/url';

const url = useUrlFunc()

const announces = ref<api.Announce[]>()


//  お知らせ取得
const announcesQuery = useQuery<
  api.AnnouncesQuery,
  api.AnnouncesQueryVariables
>(api.AnnouncesDocument, {
  where: {
    AND: [
      {
        OR: [
          {
            publishedAt: {
              lt: new Date(),
            },
          },
          {
            publishedAt: {
              equals: null,
            },
          }
        ]
      },
      {
        OR: [
          {
            disabledAt: {
              gt: new Date(),
            },
          },
          {
            disabledAt: {
              equals: null,
            },
          }
        ]
      }
    ]
  },
  orderBy: [
    {
      publishedAt:{
        sort: api.SortOrder.Desc,
      }
    },
  ]
})

announcesQuery.onResult(result => {
  announces.value = result.data?.announces as api.Announce[]
})

announcesQuery.onError(error => {
  console.log(error)
  url.show500(error.message)
})

/**
 * 日付をフォーマットします
 * @param val
 */
const formatDate = function (val?: string): string {
  return useFormatFunc().formatDate(val, 'YYYY年MM月DD日')
}

const omittedText30 = function (text:string): string {
  if (!text) return text
  return text.length > 30 ? text.slice(0, 30) + "…" : text;
}

// AnnounceDialog
const openAnnounceDialog = ref<any>(false)
let announceId = 0

const clickAnnounce = (i:number) => {
  openAnnounceDialog.value = true;
  announceId = i
}
const cancelAnnounceDialog = ():void => {
  openAnnounceDialog.value = false;
}
const successAnnounceDialog = ():void => {
  openAnnounceDialog.value = true;
}

</script>

<style lang="scss" scoped>
.announce-widget {
  max-width: 200px;

  .announce-widget--container {
    border: 2px solid rgb(var(--v-theme-black));
    border-radius: 5px;
  }

  &::v-deep(h4) {
    font-weight: 400;
    font-size: 20px;
  }

  &::v-deep(.v-list-item-title) {

    color: rgb(var(--v-theme-black));
    opacity: 1;
    font-weight: bold;
    margin-bottom: 0.4rem;
    font-size: 12px;
  }

  &::v-deep(.v-list-item-subtitle) {
    color: rgb(var(--v-theme-black));
    opacity: 1;
    line-height: 1.6;
    color: #4880D3;
    text-decoration: underline;
  }

  &:visited {
    &::v-deep(.v-list-item-subtitle) {
      color:#551A8B;
    }
}
}
</style>
